import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
// import Cookies from 'js-cookie';

const MonthlyClosing = ({ onSubmit }) => {
  // const [companyList, setCompanyList] = useState([]);
  const [selectedCID, setSelectedCID] = useState('');
  const [inventory, setInventory] = useState([]);
  const [piutang, setPiutang] = useState([]);
  const [penjualan, setPenjualan] = useState([]);
  const [activeTab, setActiveTab] = useState('inventory');
  const [agreed, setAgreed] = useState(false);
  const [showStatement, setShowStatement] = useState(false);

  const handleCheckboxChange = () => {
    setAgreed(!agreed);
  };
  useEffect(() => {
    const storedCID = localStorage.getItem("cid");
    if (storedCID) {
      setSelectedCID(storedCID);
    }
  }, []);

  const handleSubmit = async () => {
    if (onSubmit) onSubmit();

    if (!selectedCID) return;
    try {
      // const token = Cookies.get('token');
      const token = localStorage.getItem('token')
      const res = await api.post('mclosing/closingreq', { cid: selectedCID }, {
        headers: { authorization: token },
      });
      alert(res.data.responseMessage);
    } catch (error) {
      console.error('Error fetching inventory:', error);
    }



  };

  // useEffect(() => {
  //   const fetchCompanies = async () => {
  //     try {
  //       const token = Cookies.get('token');
  //     const token=localStorage.getItem('token')
  //       const res = await api.get('/cred/cidavailable', {
  //         headers: { authorization: token },
  //       });
  //       setCompanyList(res.data.data);
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   };
  //   fetchCompanies();
  // }, []);

  useEffect(() => {
    const fetchInventory = async () => {
      if (!selectedCID) return;
      try {
        // const token = Cookies.get('token');
        const token = localStorage.getItem('token')
        const res = await api.post('mclosing/invlist', { cid: selectedCID }, {
          headers: { authorization: token },
        });
        setInventory(res.data.data);
      } catch (error) {
        console.error('Error fetching inventory:', error);
      }
    };
    fetchInventory();

    const fetchPiutang = async () => {
      if (!selectedCID) return;
      try {
        // const token = Cookies.get('token');
        const token = localStorage.getItem('token')
        const res = await api.post('mclosing/piutang', { cid: selectedCID }, {
          headers: { authorization: token },
        });
        setPiutang(res.data.data);
      } catch (error) {
        console.error('Error fetching inventory:', error);
      }
    };
    fetchPiutang();

    const fetchPenjualan = async () => {
      if (!selectedCID) return;
      try {
        // const token = Cookies.get('token');
        const token = localStorage.getItem('token')
        const res = await api.post('mclosing/penjualan', { cid: selectedCID }, {
          headers: { authorization: token },
        });
        setPenjualan(res.data.data);
      } catch (error) {
        console.error('Error fetching inventory:', error);
      }
    };
    fetchPenjualan()
  }, [selectedCID]);

  const formatNumber = (num) => {
    if (typeof num !== 'number') return '';
    const precision = Math.abs(num) < 1 ? 4 : 2;
    return num.toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    });
  };

  const getTotal = (key) => {
    return inventory.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
  };

  const getTotalPiu = (key) => {
    return piutang.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
  };
  const getTotalJual = (key) => {
    return penjualan.reduce((sum, item) => sum + (parseFloat(item[key]) || 0), 0);
  };


  return (
    <div className="container-fluid page-wrapper">

      <div className="page-header ">
        <h3 className="fw-bold mb-1">Monthly Closing</h3>
        <p className="text-body-secondary" >
          Di bawah ini adalah pernyataan yang harus anda submit ketika <cite title="Source Title">Menutup Transaksi Bulanan</cite>
        </p>
      </div>
      
      <div className="mb-4  border rounded p-3 shadow-sm alert alert-secondary">
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => setShowStatement(!showStatement)}
          className="d-flex justify-content-between align-items-center"
        >
          <strong>📋 Pernyataan Data Bulanan</strong>
          <span>{showStatement ? '▲ Tutup' : '▼ Buka'}</span>
        </div>

        {showStatement && (
          <div className="mt-3">
            <p>Halaman ini merupakan bagian dari proses <em>closing</em> transaksi bulanan, untuk memastikan seluruh data operasional dan keuangan telah dicatat dengan benar.</p>
            <p>Data yang ditampilkan meliputi:</p>
            <ul>
              <li><strong>Inventory</strong>: Posisi akhir stok barang & nilai jual.</li>
              <li><strong>Piutang</strong>: Tagihan aktif, pembayaran, dan sisa.</li>
              <li><strong>Summary Penjualan</strong>: Ringkasan penjualan dan estimasi laba/rugi.</li>
            </ul>
            <p>Dengan menyetujui pernyataan ini, Anda menyatakan bahwa data telah sesuai dengan kondisi nyata di lapangan.</p>

            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreeStatement"
                checked={agreed}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="agreeStatement">
                Saya menyatakan bahwa data yang ditampilkan benar dan sesuai dengan kondisi di lapangan.
              </label>
            </div>

            <button
              className="btn btn-success"
              disabled={!agreed}
              onClick={handleSubmit}
            >
              ✅ Submit Closing
            </button>
          </div>
        )}
      </div>


      <div class="">
        <div class="page-tabs">
          <ul className="nav nav-tabs mb-2" >
            <li className="nav-item">
              <button className={`nav-link ${activeTab === 'inventory' ? 'active' : ''}`} onClick={() => setActiveTab('inventory')}>Inventory</button>
            </li>
            <li className="nav-item">
              <button className={`nav-link ${activeTab === 'piutang' ? 'active' : ''}`} onClick={() => setActiveTab('piutang')}>Piutang</button>
            </li>
            <li className="nav-item">
              <button className={`nav-link ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => setActiveTab('summary')}>Selling Summary</button>
            </li>
          </ul>
        </div>


        <div className="page-content">
          {activeTab === 'inventory' && (
            <div className="table-responsive scrollable-table">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Product Code</th>
                    <th>Product Name</th>
                    <th>COGS</th>
                    <th>Sell Price</th>
                    <th>Total Qty</th>
                    <th>Total COGS</th>
                    <th>Total Selling Price</th>
                  </tr>
                </thead>
                <tbody>
                  {inventory.map((item) => (
                    <tr key={item.Productcode}>
                      <td>{item.Productcode}</td>
                      <td>{item.ProductName}</td>
                      <td className="text-end">{formatNumber(item.cogs)}</td>
                      <td className="text-end">{formatNumber(item.sellPrice)}</td>
                      <td className="text-end">{formatNumber(item.TotalQty)}</td>
                      <td className="text-end">{formatNumber(item.TotalHPP)}</td>
                      <td className="text-end">{formatNumber(item.TotalSellingPrice)}</td>
                    </tr>
                  ))}
                  {inventory.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center">No data available</td>
                    </tr>
                  )}
                  {inventory.length > 0 && (
                    <tr className="fw-bold bg-light">
                      <td colSpan="2" className="text-end">TOTAL</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-end">{formatNumber(getTotal('TotalHPP'))}</td>
                      <td className="text-end">{formatNumber(getTotal('TotalSellingPrice'))}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          )}

          {activeTab === 'piutang' && (
            <div className="table-responsive scrollable-table">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Salespoint</th>
                    <th>Total Tagihan</th>
                    <th>Total Pembayaran</th>
                    <th>Sisa Piutang</th>
                    <th>Unused Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {piutang.map((item) => (
                    <tr key={item.KodeCVS}>
                      <td>{item.KodeCVS}</td>
                      <td>{item.SPName}</td>
                      <td className="text-end">{formatNumber(item.TotalPiutang)}</td>
                      <td className="text-end">{formatNumber(item.TotalPayment)}</td>
                      <td className="text-end">{formatNumber(item.SisaPiutang)}</td>
                      <td className="text-end">{formatNumber(item.UnusedPayment)}</td>
                    </tr>
                  ))}
                  {piutang.length === 0 && (
                    <tr>
                      <td colSpan="6" className="text-center">No data available</td>
                    </tr>
                  )}
                  {piutang.length > 0 && (
                    <tr className="fw-bold bg-light">
                      <td colSpan="2" className="text-end">TOTAL</td>
                      <td className="text-end">{formatNumber(getTotalPiu('TotalPiutang'))}</td>
                      <td className="text-end">{formatNumber(getTotalPiu('TotalPayment'))}</td>
                      <td className="text-end">{formatNumber(getTotalPiu('SisaPiutang'))}</td>
                      <td className="text-end">{formatNumber(getTotalPiu('UnusedPayment'))}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {activeTab === 'summary' && (

            <div className="table-responsive scrollable-table">
              {/* <div><p>{JSON.stringify(penjualan)}</p></div> */}
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Product Code</th>
                    <th>Product Name</th>
                    <th>COGS Average</th>
                    <th>Sell Price Average</th>
                    <th>Qty</th>
                    <th>Subtotal COGS</th>
                    <th>Subtotal Selling Price</th>
                    <th>Profit Loss</th>
                  </tr>
                </thead>
                <tbody>
                  {penjualan.map((item) => (
                    <tr key={item.Productcode}>
                      <td>{item.ProductCode}</td>
                      <td>{item.ProductName}</td>
                      <td className="text-end">{formatNumber(0)}</td>
                      <td className="text-end">{formatNumber(0)}</td>
                      <td className="text-end">{formatNumber(Number(item.Qty))}</td>
                      <td className="text-end">{formatNumber(item.TotalHPP)}</td>
                      <td className="text-end">{formatNumber(item.TotalHarga)}</td>
                      <td className="text-end">{formatNumber(item.TotalHarga - item.TotalHPP)}</td>
                    </tr>
                  ))}
                  {penjualan.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center">No data available</td>
                    </tr>
                  )}
                  {penjualan.length > 0 && (
                    <tr className="fw-bold bg-light">
                      <td colSpan="2" className="text-end">TOTAL</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-end">{formatNumber(getTotalJual('TotalHPP'))}</td>
                      <td className="text-end">{formatNumber(getTotalJual('TotalHarga'))}</td>
                      <td className="text-end">{formatNumber(getTotalJual('TotalHarga') - getTotalJual('TotalHPP'))}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonthlyClosing;
